import React, { useEffect, useState } from 'react'
import Grid from '@mui/material/Grid';
import { useRef } from 'react';
import {
    FormGroup,
    FormControlLabel,
    Checkbox, Typography
} from "@mui/material";
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import axios from "../../../lib/axios";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CustomAutocomplete from '../../../Components/AutoComplete/AutoComplete'
import checkAndLock from "../../../GlobalFunction/checkAndLock";
import UnLock from "../../../GlobalFunction/UnLock";
import CrudButtons from '../../../GlobalFunction/CrudButtons';
// import { useModulePermissions } from '../../../GlobalFunction/useModulePermissions';
import ReportTable from '../../../atoms/ReportFolder/ReportTable';
import { useReactToPrint } from 'react-to-print';
import CustomAutoCompleteNew from '../../AutoComplete/CustomAutoCompleteNew';


const columns = [
    { id: 'RowNum', label: 'S.No.', minWidth: 170 },
    { id: 'CityName', label: 'City', minWidth: 170 },
    { id: 'CityAbrv', label: 'ShortName', minWidth: 100 },
    { id: 'CountryName', label: 'Country', minWidth: 170 },
    { id: 'StateName', label: 'State', minWidth: 170 },
    { id: 'ZoneName', label: 'Zone/Region', minWidth: 170 },
    { id: 'CityCode', label: 'CityCode', minWidth: 100 }
];

const City = () => {
    const [formData, setFormData] = useState({
        CountryName: '',
        StateName: '',
        ZoneName: '',
        CityName: '',
        ShortName: '',
        CityCode: ''
    });

    // const permissions = useModulePermissions("City Master");

    const [error, setError] = useState({
        country: false,
        state: false,
        zone: false,
        city: false,
        cityCode: false
    });

    const navigate = useNavigate();

    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([])
    const [zone, setZone] = useState([])
    const [isFormDisabled, setIsFormDisabled] = useState(true);
    const [countryIds, setCountryIds] = useState([]);
    const location = useLocation();
    const [currentCityId, setCurrentCityId] = useState(null);
    const [mode, setMode] = useState('view');
    const [Status, setStatus] = useState("1");
    const [lastInsertedCityId, setLastInsertedCityId] = useState(null);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const UserId = sessionStorage.getItem('UserId')
    const [DataForPrint, setDataForPrint] = useState({});
    const [rows, setRows] = useState([]);
    const [isRefreshingStates, setIsRefreshingStates] = useState(false);
    const [isRefreshingCountries, setIsRefreshingCountries] = useState(false);
    const contentRef = useRef(null);
    const handlePrint = useReactToPrint({ contentRef });

    const countryRef = useRef(null);
    const stateRef = useRef(null);
    const zoneRef = useRef(null);
    const cityRef = useRef(null);
    const shortNameRef = useRef(null);
    const cityCodeRef = useRef(null);

    const openStateTab = () => {
        window.open('/state');
    }
    const openCountryTab = () => {
        window.open('/country');
    }

    const handleRefreshCountries = async () => {
        setIsRefreshingCountries(true);
        try {
            const response = await axios.get(`StateMst/getcountydrp`);
            setCountries(response.data.Data);
            const idMapping = response.data.Data.reduce((acc, country) => {
                acc[country.name] = country.id;
                return acc;
            }, {});
            setCountryIds(idMapping);
        } catch (err) {
            console.error('Error refreshing countries:', err);
        } finally {
            setTimeout(() => {
                setIsRefreshingCountries(false);
            }, 300);
        }
    };

    const handleRefreshStates = async () => {
        if (formData.CountryName) {
            setIsRefreshingStates(true);
            try {
                const countryId = countryIds[formData.CountryName];
                if (countryId) {
                    const response = await axios.post(
                        `stateMst/getCountrywiseStatedrp`,
                        { CountryId: countryId }
                    );
                    setStates(response.data.Data);
                }
            } catch (err) {
                console.error('Error refreshing states:', err);
            } finally {
                setTimeout(() => {
                    setIsRefreshingStates(false);
                }, 300);
            }
        } else {
            console.warn('Please select a country first to refresh states.');
        }
    };

    useEffect(() => {
        if (location.state && location.state.CityId) {
            setCurrentCityId(location.state.CityId);
            fetchCityData(location.state.CityId);
            setMode('view');
        } else {
            setMode('add');
            setIsFormDisabled(false);
        }
    }, [location]);

    useEffect(() => {
        const getRow = async () => {
            const params = {
                start: 1,
                PageSize: 1,
                SearchText: ""
            };

            try {
                const res = await axios.post('CityMst/getAllcityMstDashBoard', { params });

                if (res.data && res.data.Data) {
                    setRows(res.data.Data);
                    setDataForPrint(res.data.Data);
                } else {
                    console.error('No data found in response');
                }
            } catch (err) {
                console.error('Error fetching data:', err);
            }
        };

        getRow();
    }, []);

    useEffect(() => {
        const getStatesUpdate = async () => {
            if (formData.CountryName) {
                try {
                    const response = await axios.post(
                        `stateMst/getCountrywiseStatedrp`,
                        { CountryId: parseInt(formData.CountryName) }
                    );
                    setStates(response.data.Data);
                } catch (err) {
                    console.log(err);
                }
            }
        };
        getStatesUpdate();
    }, [formData.CountryName]);

    const fetchCityData = async (id, flag) => {

        try {
            const response = await axios.post(`CityMst/RetrivecityMst`, {
                CityId: parseInt(id),
                Flag: flag
            });

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                const cityData = response.data.Data[0];
                setFormData({
                    CountryName: cityData.CountryId ? cityData.CountryId.toString() : "",
                    StateName: cityData.StateId,
                    ZoneName: cityData.ZoneId,
                    CityName: cityData.CityName,
                    ShortName: cityData.CityAbrv,
                    CityCode: cityData.CityCode
                });
                setStatus(cityData.Status.toString() || "0");
                setIsFormDisabled(true);
                setCurrentCityId(cityData.CityId);
            } else if (response.data.Status === 1 && response.data.responseStatusCode === 2) {
                toast.info(response.data.Message);
            } else {
                toast.error('Failed to fetch city data');
            }
        } catch (error) {
            console.error('Error fetching city data:', error);
            toast.error('Error fetching city data. Please try again.');
        }
    };

    const handlePrevious = async () => {
        if (currentCityId && currentCityId > 1) {
            await fetchCityData(currentCityId, "P");
        }
    };

    const handleNext = async () => {
        if (currentCityId) {
            await fetchCityData(currentCityId, "N");
        }
    };

    useEffect(() => {
        const getCountries = async () => {
            try {
                const response = await axios.get(`StateMst/getcountydrp`);
                setCountries(response.data.Data);
                const idMapping = response.data.Data.reduce((acc, country) => {
                    acc[country.name] = country.id;
                    return acc;
                }, {});
                setCountryIds(idMapping);
            } catch (err) {
                console.log(err);
            }
        };
        getCountries();
    }, []);


    useEffect(() => {
        const getStates = async () => {
            if (formData.CountryName) {
                try {
                    const countryId = countryIds[formData.CountryName];
                    if (countryId) {
                        const response = await axios.post(
                            `stateMst/getCountrywiseStatedrp`,
                            { CountryId: countryId }
                        );
                        setStates(response.data.Data);
                    }
                } catch (err) {
                    console.log(err);
                }
            }
        };
        getStates();
    }, [formData.CountryName, countryIds]);

    useEffect(() => {
        const getZone = async () => {
            await axios.get(`CityMst/getzonedrp`).then((res) => {
                setZone(res.data.Data)
            }).catch((err) => {
                console.log(err)
            })
        }
        getZone()
    }, [])


    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));


        if (name === 'country') {
            setFormData(prevState => ({
                ...prevState,
                state: ''
            }));
        }

        if (name === 'country' && value !== '') {
            setTimeout(() => {
                cityCodeRef.current.focus();
            }, 100000);
        }
    };

    const handleChangeStatus = (event) => {
        const updatedStatus = event.target.checked ? "1" : "0";
        setStatus(updatedStatus);
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            if (event.target === countryRef.current) {
                stateRef.current.focus();
            } else if (event.target === stateRef.current) {
                cityRef.current.focus();
            } else if (event.target === cityRef.current) {
                zoneRef.current.focus();
            } else if (event.target === zoneRef.current) {
                shortNameRef.current.focus();
            } else {
                cityCodeRef.current.focus();
            }
        }
    };

    const handleSave = async () => {

        let hasError = false;

        if (!formData.CountryName) {
            toast.error('Country name is required');
            setError(prev => ({ ...prev, CountryName: true }));
            hasError = true;
        } else {
            setError(prev => ({ ...prev, CountryName: false }));
        }

        if (!formData.StateName) {
            toast.error('State name is required');
            setError(prev => ({ ...prev, StateName: true }));
            hasError = true;
        } else {
            setError(prev => ({ ...prev, StateName: false }));
        }

        if (!formData.ZoneName) {
            toast.error('Zone name is required');
            setError(prev => ({ ...prev, ZoneName: true }));
            hasError = true;
        } else {
            setError(prev => ({ ...prev, ZoneName: false }));
        }

        if (hasError) {
            return;
        }


        try {
            const payload = {
                cityName: formData.CityName,
                CityAbrv: formData.ShortName,
                StateId: parseInt(formData.StateName),
                ZoneId: parseInt(formData.ZoneName),
                CityCode: formData.CityCode,
                Status: Status
            };

            let response;
            if (mode === 'edit') {
                payload.CityId = currentCityId;
                payload.UpdatedBy = parseInt(UserId, 10);
                response = await axios.patch(`cityMst/UpdatecityMst`, payload);
            } else {
                payload.CreatedBy = parseInt(UserId, 10);
                response = await axios.post(`cityMst/InsertcityMst`, payload);
            }

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                toast.success(response.data.Message);
                if (mode === 'add') {
                    setLastInsertedCityId(response.data.Data)
                    await fetchCityData(response.data.Data);
                    setMode('view');
                    setIsFormDisabled(true);
                    setCurrentCityId(response.data.Data);
                } else {
                    await UnLock(currentCityId, "MstCity", "CityId");
                    setMode('view');
                }
                setIsFormDisabled(true);
            } else {
                toast.error(response.data.Message || 'Operation failed');
            }
        } catch (error) {
            console.error('Error saving/updating city:', error);
            toast.error('Error saving/updating city. Please try again.');
        }
    };

    const handleEdit = async () => {

        let Flag = await checkAndLock(currentCityId, "MstCity", "CityId");
        switch (Flag) {
            case 0:
                setMode("edit");
                setIsFormDisabled(false);
                break;
            case 1:
                toast.info("Record  Already Locked", { autoClose: 500 });
                break;
            case 2:
                toast.info("Record Failed To Locked", { autoClose: 500 });
                break;
            default:
                toast.info("Something Went Wrong", { autoClose: 500 });
        }
    };

    const handleAdd = () => {
        setMode('add');
        setIsFormDisabled(false);
        setFormData({
            CountryName: '',
            StateName: '',
            ZoneName: '',
            CityName: '',
            ShortName: '',
            CityCode: ''
        });
        setCurrentCityId(null);

        setTimeout(() => {
            countryRef.current.focus();
        }, 0);
    };

    const handleCancel = async () => {
        if (mode === 'add') {
            try {
                await fetchCityData(1, "L");
                setMode('view');
                setIsFormDisabled(true);
            } catch (error) {
                toast.error('Error occurred while cancelling. Please try again.');
            }
        } else if (mode === 'edit') {
            if (currentCityId) {
                await fetchCityData(currentCityId);
                await UnLock(currentCityId, "MstCity", "CityId");
            }
            setMode('view');
            setIsFormDisabled(true);
        }

    };

    const resetForm = () => {
        setFormData({
            CountryName: '',
            StateName: '',
            ZoneName: '',
            CityName: '',
            ShortName: '',
            CityCode: ''
        });
        setCurrentCityId(null);
        setMode('view');
    };

    const handleExit = () => {
        navigate('/citytable')
    }
    const handleDeleteClick = () => {
        setOpenConfirmDialog(true);
    };

    const handleCloseConfirmDialog = () => {
        setOpenConfirmDialog(false);
    };

    const handleConfirmDelete = async () => {

        let Flag = await checkAndLock(currentCityId, "MstCity", "CityId");
        switch (Flag) {
            case 0:
                setOpenConfirmDialog(false);
                await fetchCityData(currentCityId, "D");
                await fetchCityData(currentCityId, "N");
                setMode('view');
                setIsFormDisabled(true);
                break;
            case 1: toast.info("Record  Already Locked", { autoClose: 500 });
                break;
            case 2: toast.info("Record Failed To Locked", { autoClose: 500 });
                break;
            default: toast.info("Something Went Wrong", { autoClose: 500 });

        }

    };

    return (
        <>

            <Box className="form-container" sx={{ height: { xs: '700px', sm: '550px' } }}>

                <ToastContainer />
                <Grid container spacing={2} className='form_grid'>

                    <Grid item xs={12} className='form_title'
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            marginTop: '20px',
                            flexDirection: { xs: 'column', sm: 'row', md: 'row' }
                        }}
                    >
                        <Grid
                            sx={{
                                display: 'flex',
                                justifyContent: { xs: 'center', sm: 'flex-start' },
                                marginBottom: { xs: '10px', sm: 0 }
                            }}
                        >
                            <Button
                                variant="contained"
                                size="small"
                                className='three-d-button-previous'
                                onClick={handlePrevious}
                                sx={{ backgroundColor: '#635BFF', display: { xs: 'none', sm: 'block' } }}
                                disabled={mode !== 'view' || !currentCityId || currentCityId === 1}
                            >
                                <KeyboardArrowLeftIcon />
                            </Button>

                            <Button
                                variant="contained"
                                className='three-d-button-next'
                                size="small"
                                // sx={{ backgroundColor: '#635bff', margin: '0px 10px' }}
                                onClick={handleNext}
                                sx={{ backgroundColor: '#635BFF', display: { xs: 'none', sm: 'block' } }}
                                disabled={mode !== 'view' || !currentCityId}
                            >
                                <NavigateNextIcon />
                            </Button>
                        </Grid>

                        <Typography
                            variant="h5"
                            sx={{
                                margin: 'Auto',
                                textAlign: { xs: 'center', sm: 'center' },
                                fontSize: { xs: '24px', sm: '18px', md: '24px' }
                            }}
                        >
                            City Master
                        </Typography>

                        <Grid sx={{ display: "flex", justifyContent: "end" }}>
                            <CrudButtons
                                moduleName="City Master"
                                mode={mode}
                                onAdd={handleAdd}
                                onEdit={handleEdit}
                                onView={handlePrint}
                                onDelete={handleConfirmDelete}
                                onExit={handleExit}
                                onPrevious={handlePrevious}
                                onNext={handleNext}
                                readOnlyMode={isFormDisabled}
                            />
                        </Grid>
                    </Grid>


                    <Grid item xs={12} md={6} lg={6} className='form_field' >
                        {/* <CustomAutocomplete
                            id="CountryName-autocomplete"
                            name='CountryName'
                            label={
                                <span>
                                    Country <span style={{ color: 'red' }}>*</span>
                                </span>
                            }
                            options={countries}
                            value={
                                countries.find(
                                  (CountryName) => CountryName.Id == formData.CountryName
                                ) || null
                              }
                            onChange={handleInputChange}
                            disabled={isFormDisabled}
                            error={error.CountryName}
                            helperText={error.CountryName ? '' : ''}
                            ref={countryRef}
                            onKeyDown={handleKeyPress}
                        /> */}

                        <CustomAutoCompleteNew
                            id="CountryName-autocomplete"
                            name="CountryName"
                            label={
                                <span>
                                    Country <span style={{ color: 'red' }}>*</span>
                                </span>
                            }
                            options={countries}
                           value={countries.find((CountryName) => CountryName.Id == formData.CountryName) || null
                              }
                            onChange={handleInputChange}
                            disabled={isFormDisabled}
                            error={!!error.CountryName}
                            helperText={error.CountryName ? 'This field is required.' : ''}
                            ref={countryRef}
                            onKeyDown={handleKeyPress}
                            onAddClick={openCountryTab}
                            onRefreshClick={handleRefreshCountries}
                            isRefreshing={isRefreshingCountries}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={6} className='form_field'>

                        <CustomAutoCompleteNew
                            id="StateName-autocomplete"
                            name="StateName"
                            label={
                                <span>
                                    State <span style={{ color: 'red' }}>*</span>
                                </span>
                            }
                            options={states}
                            value={states.find((state) => state.Id === formData.StateName) || null}
                            onChange={handleInputChange}
                            disabled={isFormDisabled}
                            error={!!error.StateName}
                            helperText={error.StateName ? 'This field is required.' : ''}
                            ref={stateRef}
                            onKeyDown={handleKeyPress}
                            onAddClick={openStateTab}
                            onRefreshClick={handleRefreshStates}
                            isRefreshing={isRefreshingStates}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={6} className='form_field'>
                        <TextField
                            id="CityName"
                            name="CityName"
                            label="City"
                            variant="filled"
                            fullWidth
                            className="custom-textfield"
                            value={formData.CityName}
                            onChange={handleInputChange}
                            disabled={isFormDisabled}
                            error={error.city}
                            helperText={error.city ? '' : ''}
                            inputRef={cityRef}
                            onKeyDown={handleKeyPress}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={6} className='form_field'>
                        <CustomAutocomplete
                            options={zone}
                            id="ZoneName-autocomplete"
                            name='ZoneName'
                            label="Select Zone"
                            value={zone.find(z => z.Id === formData.ZoneName) || null}
                            onChange={handleInputChange}
                            disabled={isFormDisabled}
                            error={error.ZoneName}
                            helperText={error.ZoneName ? '' : ''}
                            ref={zoneRef}
                            onKeyDown={handleKeyPress}
                        />
                    </Grid>
                    <Grid item xs={12} className='form_field'>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6} lg={6}>
                                <TextField
                                    id="ShortName"
                                    name="ShortName"
                                    label="Short Name"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.ShortName}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={shortNameRef}
                                    onKeyDown={handleKeyPress}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={4}>
                                <TextField
                                    id="CityCode"
                                    name="CityCode"
                                    label="City Code"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.CityCode}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    error={error.cityCode}
                                    helperText={error.cityCode ? '' : ''}
                                    inputRef={cityCodeRef}
                                    onKeyDown={handleKeyPress}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={2} >
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                disabled={isFormDisabled}
                                                checked={Status === "1"}
                                                onChange={handleChangeStatus}
                                            />
                                        }
                                        label="Status"
                                    />
                                </FormGroup>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_button">
                        {mode === 'view' && (
                            <>
                                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #d4d4d4, #d4d4d4)' }} onClick={handleAdd} disabled>
                                    Submit
                                </Button>
                                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #b9d0e9, #e9f2fa)' }} onClick={handleEdit}
                                    disabled
                                >
                                    Cancel
                                </Button>
                            </>
                        )}
                        {(mode === 'edit' || mode === 'add') && (
                            <>

                                <Button variant="contained" sx={{ mr: 1 }} onClick={handleSave} >
                                    Submit
                                </Button>
                                <Button variant="contained"
                                    onClick={handleCancel}>
                                    Cancel
                                </Button>

                            </>
                        )}
                    </Grid>
                </Grid>
            </Box>

            <div style={{ display: 'none' }}>
                {Object.keys(DataForPrint).length > 0 && <ReportTable
                    columns={columns}
                    rows={rows}
                    title="City Master"
                    contentRef={contentRef}
                    customStyles={{ backgroundColor: '#f5f5f5' }}
                />
                }
            </div>

            <Dialog
                open={openConfirmDialog}
                onClose={handleCloseConfirmDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Confirm Deletion"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this data.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button sx={{
                        backgroundColor: '#635bff',
                        color: 'white',
                        '&:hover': {
                            backgroundColor: '#1565c0',
                            color: 'white'
                        }
                    }} onClick={handleConfirmDelete} >
                        Yes
                    </Button>
                    <Button sx={{
                        backgroundColor: '#635bff',
                        color: 'white',
                        '&:hover': {
                            backgroundColor: '#1565c0',
                            color: 'white'
                        }

                    }} onClick={handleCloseConfirmDialog}>No</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default City